import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MaterialChipsInputModule} from '../tags/materialChipsInput.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgxSelectModule} from 'ngx-select-ex';
import {TranslatePipeModule} from '../../translate/translate.pipe.module';
import {FileUploadModule} from 'ng2-file-upload';
import {ControlMessageModule} from '../../control-message/control-message.module';
import {ClientManagerComponent} from './client-manager.component';
import {GenericModalModule} from '../../modal/generic-modal.module';
import {CreateObjectDialogModule} from '../../createObjectDialog/create-object-dialog.module';

@NgModule({
    imports: [
        CommonModule, MaterialChipsInputModule, FormsModule, ReactiveFormsModule, NgxSelectModule, TranslatePipeModule, FileUploadModule, ControlMessageModule, GenericModalModule, CreateObjectDialogModule
    ],
    declarations: [ClientManagerComponent],
    providers: [],
    exports: [ClientManagerComponent]
})
export class EmailModule {

}
